// ACTS AS ENUM FOR ALL THE CONSTANTS USED IN THE APP
const Constants = {
  SEVERITY: [1, 2, 3, 4, 5],
  ALERTS: ['mechanical', 'software', 'human'],
  PREDICTIONS: ['prediction', 'real'],
  INTERVAL_DURATION: 1500,
  MAX_ITEMS: 110
};

export default Constants;
